import React, { Component } from 'react';
import { dispatch } from '@@/store';
import clazz from 'classnames';
import { getFlatMenuKeys } from '../SiderMenu/utils';
import BaseMenu from '../SiderMenu/BaseMenu';
import styles from './index.less';
import RightContent from '../GlobalHeader/RightContent';
import Logo from '../SiderMenu/Logo';
import CustomMenu from './CustomMenu';
class TopNavHeader extends Component {
    render() {
        const { className, style, menuData, currentRoute, sso, contentWidth, } = this.props;
        const flatMenuKeys = getFlatMenuKeys(menuData);
        return (<div className={clazz(className, styles.header)} style={style}>
        <div className={clazz(styles.main, contentWidth === 'fixed' ? styles.wide : '')}>
          <div className={styles.left}>
            <div className={styles.logo} key="logo" id="logo">
              <Logo collapsed={true} onClick={() => {
            dispatch.router.push(flatMenuKeys[0]);
        }}/>
            </div>
            <div className={styles.menu}>
              <BaseMenu mode="horizontal" flatMenuKeys={flatMenuKeys} currentRoute={currentRoute} {...this.props}/>
              <CustomMenu />
            </div>
          </div>
          <RightContent className={styles.right} sso={sso}/>
        </div>
      </div>);
    }
}
export default TopNavHeader;
